<template>
  <div>
    <ul class="footer">
      <router-link to="/earlyinformation" tag="li">
        <img :src="tabername== 1 ? require(`../assets/images/leid-active.png`) :require(`../assets/images/leid.png`)" >
        <span :class="{color : tabername == 1}">预警信息</span>
      </router-link>
      <router-link to="/feedbackinformation" tag="li" v-if="role">
        <img :src="tabername == 2 ? require(`../assets/images/fank-active.png`) :require(`../assets/images/fank.png`)" >
        <span :class="{color : tabername == 2}">信息反馈</span>
      </router-link>
      <router-link to="/user" tag="li">
        <img :src="tabername == 3 ? require(`../assets/images/user-active.png`) :require(`../assets/images/user.png`)" >
        <span :class="{color : tabername == 3}">个人中心</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['tabername'],
  data () {
    return {
      role: ''
    }
  },
  created () {
    if (this.$store.state.role === 2) {
      this.role = true
    }
  }
}
</script>

<style lang='scss' scoped>
  .footer{
    width: 100%;
    height: 8.12vh;
    background-color: #00BDFF;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    li{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font: .1rem SourceHanSansCN-Regular;
      font-weight: Regular;
      color:#F9F9F9;
      img{
        width: .24rem;
        height: .24rem;
        position: relative;
        margin: auto;
      }
      .color{
        color: #00FFF6;
      }
    }
  }
</style>
